module.exports = __webpack_public_path__ + "static/img/csi_icon.d6b2da05.png";